import { useQuery } from '@tanstack/react-query';
import { COMPLIANCE_TIMEOUT_MS, runComplianceRequest } from 'src/api/complianceRequest';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch high-priority product compliance data based on a single ASIN
 */
export const useProductComplianceHighPriority = ({ asin, enabled = true }) => {
    const { getDefaultParams } = useDefaultApiParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceHighPriority', asin],
        queryFn: ({ signal }) => {
            const defaultApiParams = getDefaultParams();
            return runComplianceRequest({
                eventPrefix: 'COMPLIANCE_HIGH_PRIORITY',
                asin,
                timeoutMs: COMPLIANCE_TIMEOUT_MS.HIGH_PRIORITY,
                querySignal: signal,
                rumClient,
                request: (requestSignal) => HandshakePainterServiceApiV1.getProductComplianceHighPriority({
                    asin: asin,
                    xUserLinked: defaultApiParams.xUserLinked,
                    xJoinId: defaultApiParams.xJoinId,
                    marketplaceId: defaultApiParams.marketplaceId,
                }, { signal: requestSignal }),
            });
        },
        enabled: enabled && !!asin,
    });
};
